import { render, staticRenderFns } from "./mall_config.vue?vue&type=template&id=44f07c9e&scoped=true&"
import script from "./mall_config.vue?vue&type=script&lang=js&"
export * from "./mall_config.vue?vue&type=script&lang=js&"
import style0 from "./mall_config.vue?vue&type=style&index=0&id=44f07c9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f07c9e",
  null
  
)

export default component.exports